import LoadFile from '@/web-api/loadFile'
let downloadPluging
downloadPluging = new LoadFile({})
downloadPluging.init()

export default downloadPluging